import { FiCheck } from 'react-icons/fi'

export default function AuthGuide() {
  const bestPractices = [
    {
      title: 'Check Serial Numbers',
      description: 'Verify the serial number matches manufacturer records and is properly engraved.',
    },
    {
      title: 'Examine Movement',
      description: 'Authentic movements have precise finishing and correct markings.',
    },
    {
      title: 'Inspect Case Quality',
      description: 'Look for proper weight, finishing, and alignment of all components.',
    },
    {
      title: 'Verify Documentation',
      description: 'Ensure all papers, boxes, and accessories match the watch.',
    },
  ]

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-serif font-bold text-white mb-8">Authentication Guide</h1>

        <div className="space-y-8">
          {/* Best Practices */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-6">Best Practices</h2>
            <div className="space-y-4">
              {bestPractices.map((practice, index) => (
                <div key={index} className="flex items-start">
                  <FiCheck className="w-5 h-5 text-green-600 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">{practice.title}</h3>
                    <p className="text-gray-600 text-sm">{practice.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Red Flags */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-6">
              Common Red Flags in Counterfeits
            </h2>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3 mt-2 flex-shrink-0" />
                <span>Misaligned or poorly printed dial text and logos</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3 mt-2 flex-shrink-0" />
                <span>Incorrect font styles or sizes on dial and case back</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3 mt-2 flex-shrink-0" />
                <span>Poor finishing quality on case edges and bracelet links</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3 mt-2 flex-shrink-0" />
                <span>Shallow or incorrect engravings on case back and clasp</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3 mt-2 flex-shrink-0" />
                <span>Movement decoration that doesn't match manufacturer standards</span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div className="mt-8 bg-luxury-gold-600 text-white rounded-lg p-8 text-center">
            <h2 className="text-2xl font-serif font-bold mb-4">Ready to Examine Your Watches?</h2>
            <p className="text-luxury-gold-100 mb-6">
              Create detailed 3D models to study and compare luxury timepieces
            </p>
            <a
              href="/create"
              className="inline-flex items-center px-6 py-3 bg-white text-luxury-gold-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            >
              Create 3D Model
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
